import {createApp} from 'vue'
import AttachmentsViewer from './AttachmentsViewer'

const el = '.kb-component--community-attachments-viewer'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((CommunityAttachmentsViewerDOM)=>{
            const props = {
                files: JSON.parse(CommunityAttachmentsViewerDOM.dataset.files)
            }
            const component = createApp(AttachmentsViewer, props).use(Store)
            component.mount(CommunityAttachmentsViewerDOM)
        })
    }
}